import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    userInfo: {}
  },
  getters: {
    getUserInfo() {
      return state.userInfo
    }
  },
  mutations: {
    updateUserInfo(state, data) {
      state.userInfo = data;
    }
  },

})

// actions: {
//   getNewUserInfo(context, data) {
//     context.commit('updateUserInfo', data);
//   }
// }

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js